// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is-not-read[data-v-3df5e3db] {\n\tbackground-color: #b3b3b3;\n}\n.bg-not-title[data-v-3df5e3db] {\n\tbackground-color: #424242;\n}\n", ""]);
// Exports
module.exports = exports;
